import { FC, useCallback } from 'react'
import {
    HeaderContainer,
    TopRow,
    CountTitle,
    ViewToggleContainer,
    ToggleButton,
    ControlsRow,
    DesktopControlsGroup,
    SortWrapper,
    TitleSkeleton,
} from './styles'
import { useTranslation } from '../../../../hooks/locale'
import GridIcon from '../../../../assets/icons/grid.svg'
import ListIcon from '../../../../assets/icons/list.svg'
import ActiveFilterPills from '../../../app-components/filter-components/filter-header/active-filter-pills'
import InstantBookingBanner from './instant-booking-banner'
import SortPill from '../../../app-components/filter-components/sort-pill'
import BulkInquiryToggle from '../bulk-inquiry/bulk-inquiry-toggle'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import { useABVariant } from '../../../../utils/hooks'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../../common/constants'
import AnalyticsService from '../../../../services/analytics-service'
import { searchResultListingsPageEventCategories } from '../../../../services/analytics-service/categories'
import { searchResultListingsPageEventActions } from '../../../../services/analytics-service/actions'

interface Props {
    isGridView: boolean
    onToggleView: () => void
    primaryHeading?: string
    filterStaticData: FilterSectionTransport
}

const ListingHeader: FC<Props> = ({ isGridView, onToggleView, primaryHeading, filterStaticData }) => {
    const { t } = useTranslation()
    const { isProvidedVariantActive: isGridViewVariantActive } = useABVariant(
        AB_KEY.SRL_GRID_VIEW,
        AB_VARIANT_VERSION.ONE,
    )

    const { isProvidedVariantActive: isBookingBannerActive } = useABVariant(
        AB_KEY.BOOKING_BANNER_SRL,
        AB_VARIANT_VERSION.ONE,
    )

    const handleToggleView = useCallback(() => {
        AnalyticsService.trackClickEvent(
            searchResultListingsPageEventCategories.listViewPageSpecific.VIEW_TOGGLE,
            isGridView
                ? searchResultListingsPageEventActions.listViewPageSpecific.CLICK_LIST_VIEW
                : searchResultListingsPageEventActions.listViewPageSpecific.CLICK_GRID_VIEW,
        )
        onToggleView()
    }, [isGridView, onToggleView])

    return (
        <HeaderContainer>
            <TopRow>
                {primaryHeading ? <CountTitle>{primaryHeading}</CountTitle> : <TitleSkeleton />}
                <ViewToggleContainer $isReverse={isGridViewVariantActive}>
                    <ToggleButton isActive={!isGridView} onClick={handleToggleView} id="list-view-toggle">
                        <ListIcon width="16" />
                        {t('listText')}
                    </ToggleButton>
                    <ToggleButton isActive={isGridView} onClick={handleToggleView} id="grid-view-toggle">
                        <GridIcon width="16" />
                        {t('gridText')}
                    </ToggleButton>
                </ViewToggleContainer>
            </TopRow>
            <BulkInquiryToggle variant="mobile" />
            <ControlsRow>
                <DesktopControlsGroup>
                    <SortWrapper>
                        <SortPill filterStaticData={filterStaticData} />
                    </SortWrapper>
                    <ActiveFilterPills />
                </DesktopControlsGroup>
                <BulkInquiryToggle variant="desktop" />
            </ControlsRow>
            {isBookingBannerActive && <InstantBookingBanner />}
        </HeaderContainer>
    )
}

export default ListingHeader
